(function () {
  function initHeaderMenu() {
    const menuTrigger = document.querySelector('#ShopMenuTrigger');
    if (!menuTrigger) return;

    const parentItem = menuTrigger.closest('.header__item--hasChild');
    if (!parentItem) return;

    const setExpanded = (state) => {
      menuTrigger.setAttribute('aria-expanded', state ? 'true' : 'false');
    };

    // Mouse interactions
    parentItem.addEventListener('mouseenter', () => setExpanded(true));
    parentItem.addEventListener('mouseleave', () => setExpanded(false));

    // Keyboard interactions (fires when focus enters or leaves the menu area)
    parentItem.addEventListener('focusin', () => setExpanded(true));
    parentItem.addEventListener('focusout', (event) => {
      if (!parentItem.contains(event.relatedTarget)) {
        setExpanded(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderMenu);
  } else {
    initHeaderMenu();
  }
})();